import { format, endOfMonth, subDays } from 'date-fns'
import { DateFilterEnum } from '@/enums/date-filter-type.enum'

export const dateFormat = 'dd/MM/yyyy'
export const dateTimeTableFormat = 'd MMM, yyy / H:mm:ss'
export const invertedNormalDatePaymentFormat = 'yyyy-MM-dd'
export const dateTimeFormat = 'dd/MM/yyyy - H:mm:ss'

const today = new Date()

const dateFromTime = 'T00:00:00.000'

const dateToTime = 'T23:59:59.000'

const month = new Date(today.getFullYear(), today.getMonth())

export const dateFilters = {
  [DateFilterEnum.TODAY]: {
    dateStart: format(subDays(today, 0), 'yyyy-MM-dd') + dateFromTime,
    dateEnd: format(today, 'yyyy-MM-dd') + dateToTime,
  },
  [DateFilterEnum.LAST_7_DAYS]: {
    dateStart: format(subDays(today, 7), 'yyyy-MM-dd') + dateFromTime,
    dateEnd: format(today, 'yyyy-MM-dd') + dateToTime,
  },
  [DateFilterEnum.LAST_30_DAYS]: {
    dateStart: format(subDays(today, 30), 'yyyy-MM-dd') + dateFromTime,
    dateEnd: format(today, 'yyyy-MM-dd') + dateToTime,
  },
  [DateFilterEnum.LIFETIME]: {
    dateStart: '2018-07-16T09:30:00.000',
    dateEnd: format(endOfMonth(month), 'yyyy-MM-dd') + dateToTime,
  },
}
